import axios from 'axios';

export const SupplierDataChangeApi = {
  getServiceProviders: filter =>
    axios.get(`/api/public/info/paging/service_provider?filter=${filter}`),
  getSignString: body =>
    axios.post(`/api/info/signature/sign_string/service_provider/notify`, body),
  createNotify: body => axios.post(`/api/public/service_provider/notify/create`, body),
  getNotifications: filter =>
    axios.get(`/api/public/info/paging/service_provider/notifications?filter=${filter}`),
  annulNotify: serviceProviderId =>
    axios.post(`/api/public/service_provider/notify/annul/${serviceProviderId}`)
};
